export default __webpack_public_path__ + "static/media/dna2.c0443475.png";